/* tslint:disable */
/* eslint-disable */

/**
 * 0 = EA
 * 
 * 1 = Pack
 * 
 * 2 = M
 */
export enum PartUnitType {
  EA = 0,
  Pack = 1,
  M = 2
}
